export default __webpack_public_path__ + "img/1_8-67f3eaec.png";